/**
 * Keeps the Cart drawer "Shop the look" block in sync with the cart.
 *
 * The block's initial markup is server-rendered, but the cart drawer itself only
 * re-fetches `api-cart-items` (line items + upsell items) after an add/update/remove --
 * it does not re-render the whole `cart-drawer` section. This listens for the theme's
 * `theme:cart:change` event (dispatched after every such refresh) and swaps in the
 * "Shop the look" markup from that same endpoint, so it reflects whichever product was
 * most recently added without a full page reload.
 */
(function () {
  var selectors = {
    holder: '[data-shop-the-look-products]',
    widget: '[data-shop-the-look-widget]',
    apiShopTheLook: '[data-api-shop-the-look]',
    quickAddHolder: '[data-quick-add-holder]',
    collapsibleBody: '[data-collapsible-body]',
  };

  var attributes = {
    autoOpen: 'data-shop-the-look-auto-open',
    open: 'open',
  };

  var classes = {
    hidden: 'is-hidden',
  };

  function toggleWidgetVisibility(holder) {
    var widget = holder.closest(selectors.widget);

    if (!widget) {
      return;
    }

    var items = holder.querySelectorAll(selectors.quickAddHolder);

    widget.classList.toggle(classes.hidden, !items.length);

    if (items.length && widget.hasAttribute(attributes.autoOpen) && !widget.hasAttribute(attributes.open)) {
      widget.setAttribute(attributes.open, true);

      var body = widget.querySelector(selectors.collapsibleBody);

      if (body) {
        body.style.height = 'auto';
      }
    }
  }

  function refreshShopTheLook() {
    var holder = document.querySelector(selectors.holder);

    if (!holder || !window.theme || !window.theme.routes) {
      return;
    }

    fetch(window.theme.routes.cart_url + '?section_id=api-cart-items')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var data = new DOMParser().parseFromString(html, 'text/html').querySelector(selectors.apiShopTheLook);

        holder.innerHTML = data ? data.innerHTML : '';

        toggleWidgetVisibility(holder);
      })
      .catch(function (error) {
        console.warn('[cc-cart-shop-the-look]', error);
      });
  }

  document.addEventListener('theme:cart:change', refreshShopTheLook);
})();
